import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClipboardCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	stroke: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6667 2.66667H12C12.3536 2.66667 12.6928 2.80714 12.9428 3.05719C13.1929 3.30724 13.3333 3.64638 13.3333 4V13.3333C13.3333 13.687 13.1929 14.0261 12.9428 14.2761C12.6928 14.5262 12.3536 14.6667 12 14.6667H4C3.64638 14.6667 3.30724 14.5262 3.05719 14.2761C2.80714 14.0261 2.66667 13.687 2.66667 13.3333V4C2.66667 3.64638 2.80714 3.30724 3.05719 3.05719C3.30724 2.80714 3.64638 2.66667 4 2.66667H5.33333M6 9.33333L7.33333 10.6667L10 8M6 1.33333H10C10.3682 1.33333 10.6667 1.63181 10.6667 2V3.33333C10.6667 3.70152 10.3682 4 10 4H6C5.63181 4 5.33333 3.70152 5.33333 3.33333V2C5.33333 1.63181 5.63181 1.33333 6 1.33333Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgClipboardCheck;
